import { render, staticRenderFns } from "./shaichajiance.vue?vue&type=template&id=fca3e122&scoped=true&"
import script from "./shaichajiance.vue?vue&type=script&lang=ts&"
export * from "./shaichajiance.vue?vue&type=script&lang=ts&"
import style0 from "./shaichajiance.vue?vue&type=style&index=0&id=fca3e122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca3e122",
  null
  
)

export default component.exports